export const phoneDefaultValue = { number: '', dialCode: '61', countryCode: 'au', phone: '' };

export const initialState = { ordering: 'name', page: 1, page_size: 100, is_active: true };

export const excludeFromPreference = ['search', 'page'];
